/* eslint-disable no-console */
import React, { useState } from "react";
import { Checkbox, Segment } from "semantic-ui-react";
import { ListAttendance } from "../../../components/Admin/Attendance";
import "./Attendance.scss";

export function Attendance() {
  const [reload, setReload] = useState(false);
  const [showActive, setShowActive] = useState(true);

  const onReload = () => setReload((prevState) => !prevState);

  return (
    <div className="attendance-page">
      <div className="attendance-page__header">
        <div className="attendance-page__filters">
          <div className="attendance-page__switch-container">
            <span className={`switch-label inactive ${!showActive ? 'active' : ''}`}>Ciclos inactivos</span>
            <Checkbox
              toggle
              checked={showActive}
              onChange={() => setShowActive(!showActive)}
            />
            <span className={`switch-label success ${showActive ? 'active' : ''}`}>Ciclos activos</span>
          </div>
        </div>
      </div>
      <Segment className="attendance-page__list">
        <ListAttendance reload={reload} status={showActive ? "active" : "inactive"} />
      </Segment>
    </div>
  );
}
